import React, { Fragment,Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "./Home";
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy"; 
import Blog from "./pages/Blog";
import BlogDetails from "./components/blog/BlogDetails";
import BookingForm from "./pages/BookNow";

const Main = () => {
  return (
    <Fragment>
    <Suspense fallback={<div style={{height:"100vh"}}> </div>}>
        <Routes>
          <Route path="/" element={<Home/>}></Route>
          <Route path="/terms-of-service" element={<TermsOfService/>}></Route>
          <Route path="/privacy-policy" element={<PrivacyPolicy/>}></Route>
          <Route path="/blog" element={<Blog/>}></Route>
          <Route path="/blog-details/:id" element={<BlogDetails/>}></Route>
          <Route path="/book-now" element={<BookingForm/>}></Route>
          <Route path="*" element={<Navigate to="/" replace />}></Route>
        </Routes>
        </Suspense>
    </Fragment>
  );
};

export default Main;
